import { render } from "./family-info.vue?vue&type=template&id=c57f28b4&scoped=true"
import script from "./family-info.vue?vue&type=script&lang=js"
export * from "./family-info.vue?vue&type=script&lang=js"

import "./family-info.vue?vue&type=style&index=0&id=c57f28b4&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57f28b4"]])

export default __exports__